/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, signal, effect, Inject, OnInit } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonsComponent } from '@/app/shared/buttons/buttons.component';
import { DesyAngularModule, OrderBy } from 'desy-angular';
import { DialogModule } from 'primeng/dialog';
import { DatePickerModule } from 'primeng/datepicker';
import { SelectButtonModule } from 'primeng/selectbutton';
import { MultiSelectModule } from 'primeng/multiselect';
import { Location } from '@angular/common';
import { ConfirmationService } from 'primeng/api';
import { Router, ActivatedRoute } from '@angular/router';
import { MyAccessionsService } from '@/app/services/my-accessions.service';
import { RptsService } from '@/app/services/rpts.service';
import { ToastService } from '@/app/services/script/toast.service';
import { TabsComponent } from '@/app/shared/tabs/tabs.component';
import { SearchBarComponent } from '@/app/shared/search-bar/search-bar.component';
import { PaginationComponent } from '@/app/shared/pagination/pagination.component';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { Rpt, RptsResponse } from '@/app/interfaces/accession';
import { AccessionsList } from '@/app/interfaces/accessionsList';

@Component({
  selector: 'app-edit-rtps',
  templateUrl: './edit-rtps.component.html',
  styleUrls: ['./edit-rtps.component.scss'],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    AutoCompleteModule,
    ButtonsComponent,
    DesyAngularModule,
    DialogModule,
    DatePickerModule,
    SelectButtonModule,
    MultiSelectModule,
    TabsComponent,
    SearchBarComponent,
    PaginationComponent,
    ConfirmDialog,
  ],
  providers: [ConfirmationService],
})
export class EditRptsComponent implements OnInit {
  orderBy = OrderBy;
  accessionId: string = '';

  visibleAllRpts: boolean = false;

  selectedAdhesion: AccessionsList | null = null;
  selectedRpts: Rpt[] = [];
  rptsAll: Rpt[] = [];
  rptsTeams: Rpt[] = [];

  totalResultsCurrentRpts = signal(0);
  totalResultsAll = signal(0);
  totalResultsTeams = signal(0);
  selectedTab = signal('1');

  selectedRptCodes: string[] = [];
  selectAll = signal(false);

  currentPageAllRpts = signal(1);
  paginationSizeAllRpts = signal(15);
  seachDataAll = signal('');

  paginationSizeTeamsRpts = signal(15);
  currentPageTeamsRpts = signal(1);
  seachDataTeams = signal('');

  jobCode = JSON.parse(localStorage.getItem('userData') || '{}').roleCode || '';

  allRptsEffect = effect(() => {
    this.rptsAll = [];
    this.currentPageAllRpts();
    this.paginationSizeAllRpts();
    this.loadAllRpts();
  });

  teamsRptsEffect = effect(() => {
    this.rptsTeams = [];
    this.currentPageTeamsRpts();
    this.paginationSizeTeamsRpts();
    this.loadTeamsRpts();
  });

  constructor(
    private location: Location,
    private confirmationService: ConfirmationService,
    private router: Router,
    private route: ActivatedRoute,
    private toastService: ToastService,
    private rptsService: RptsService,
    @Inject(MyAccessionsService) private myAccessionsService: MyAccessionsService
  ) {
    this.accessionId = this.route.snapshot.paramMap.get('id') || '';
  }

  async ngOnInit() {
    await this.loadAccessionData();
  }

  async loadAccessionData() {
    try {
      const response = await this.myAccessionsService.getAccessionById(this.accessionId, 'accession');
      if (response) {
        this.selectedAdhesion = response;
        this.totalResultsCurrentRpts.set(this.selectedAdhesion?.rpts?.length || 0);
      }
    } catch (error) {
      console.error('Error loading accession data:', error);
    }
  }

  get filterParamsAllRpts() {
    return [
      {
        basicFilter: {
          orderBy: 'asc',
          nameOrderBy: '',
          currentPage: this.currentPageAllRpts(),
          sizePages: this.paginationSizeAllRpts(),
          jobCode: '',
        },
      },
      {
        advanceFilter: {
          search: this.seachDataAll(),
        },
      },
    ];
  }

  get filterParamsTeamsRpts() {
    return [
      {
        basicFilter: {
          orderBy: 'asc',
          nameOrderBy: '',
          currentPage: this.currentPageTeamsRpts(),
          sizePages: this.paginationSizeTeamsRpts(),
          jobCode: this.jobCode,
        },
      },
      {
        advanceFilter: {
          search: this.seachDataTeams(),
        },
      },
    ];
  }

  tabsItemsRpts = signal([
    { title: 'Rpts de mi equipo', id: '1' },
    { title: 'Rpts gobierno de Aragon', id: '2' },
  ]);

  onTabChange(tab: string) {
    this.selectedTab.set(tab);
  }

  handleSearchTeam(value: string) {
    this.seachDataTeams.set(value);
    this.currentPageTeamsRpts.set(1);
    this.loadTeamsRpts();
  }

  handleSearchAll(value: string) {
    this.seachDataAll.set(value);
    this.currentPageAllRpts.set(1);
    this.loadAllRpts();
  }

  async openAllRptsModal() {
    this.selectedRpts = [];
    this.visibleAllRpts = true;
    await this.loadAllRpts();
    await this.loadTeamsRpts();
  }

  removeRpt(jobCode: string) {
    if (this.selectedAdhesion?.rpts) {
      this.selectedAdhesion.rpts = this.selectedAdhesion.rpts.filter((rpt) => rpt.jobCode !== jobCode);
      this.totalResultsCurrentRpts.set(this.selectedAdhesion.rpts.length);
    }
  }

  // Checkbox selection methods
  onRptCheckboxChange(jobCode: string, checked: boolean) {
    if (checked) {
      if (!this.selectedRptCodes.includes(jobCode)) {
        this.selectedRptCodes.push(jobCode);
      }
    } else {
      this.selectedRptCodes = this.selectedRptCodes.filter((code) => code !== jobCode);
    }
    this.updateSelectAllState();
  }

  onSelectAllChange(checked: boolean) {
    if (checked) {
      this.selectedRptCodes = this.selectedAdhesion?.rpts?.map((rpt) => rpt.jobCode) || [];
    } else {
      this.selectedRptCodes = [];
    }
    this.selectAll.set(checked);
  }

  updateSelectAllState() {
    const totalRpts = this.selectedAdhesion?.rpts?.length || 0;
    const selectedCount = this.selectedRptCodes.length;
    this.selectAll.set(totalRpts > 0 && selectedCount === totalRpts);
  }

  isRptSelected(jobCode: string): boolean {
    return this.selectedRptCodes.includes(jobCode);
  }

  hasSelectedRpts(): boolean {
    return this.selectedRptCodes.length > 0;
  }

  removeSelectedRpts() {
    if (this.selectedAdhesion?.rpts && this.selectedRptCodes.length > 0) {
      this.selectedAdhesion.rpts = this.selectedAdhesion.rpts.filter(
        (rpt) => !this.selectedRptCodes.includes(rpt.jobCode)
      );
      this.selectedRptCodes = [];
      this.selectAll.set(false);
      this.totalResultsCurrentRpts.set(this.selectedAdhesion.rpts.length);
      this.toastService.showSuccess('Éxito', 'RPTs eliminados correctamente');
    }
  }

  onMainTableRowsChecked(selectedRows: any) {
    this.selectedRptCodes = Object.keys(selectedRows).filter((key) => selectedRows[key] === true);
    this.updateSelectAllState();
  }
  selectRpt(e: any) {
    if (this.selectedTab() === '1') {
      this.selectedRpts = this.rptsTeams.filter((rpt) => e[rpt.jobCode] === true);
    } else {
      this.selectedRpts = this.rptsAll.filter((rpt) => e[rpt.jobCode] === true);
    }
  }

  async saveRpts() {
    if (this.selectedRpts.length) {
      this.selectedRpts.forEach((e) => {
        const findItem = this.selectedAdhesion?.rpts?.find((el) => el.jobCode === e.jobCode);
        if (!findItem && this.selectedAdhesion?.rpts) {
          this.selectedAdhesion.rpts.push(e);
        }
      });
      this.totalResultsCurrentRpts.set(this.selectedAdhesion?.rpts?.length || 0);

      this.visibleAllRpts = false;
      this.toastService.showSuccess('Éxito', 'RPTs añadidos correctamente');
    } else {
      this.toastService.showError('Error!', 'Se debe seleccionar al menos 1 RPT');
    }
  }

  cancelRptsSelection() {
    this.visibleAllRpts = false;
  }

  async loadAllRpts() {
    if (this.visibleAllRpts) {
      try {
        const { data }: RptsResponse = await this.rptsService.getRpts(this.filterParamsAllRpts);
        if (data.items?.length) {
          this.rptsAll = data.items;
        } else {
          this.rptsAll = [];
        }
        this.totalResultsAll.set(data?.total || 0);
      } catch (error) {
        console.error('Error loading all RPTs:', error);
        this.rptsAll = [];
        this.totalResultsAll.set(0);
      }
    }
  }

  async loadTeamsRpts() {
    if (this.visibleAllRpts) {
      try {
        const { data }: RptsResponse = await this.rptsService.getRpts(this.filterParamsTeamsRpts);
        if (data.items?.length) {
          this.rptsTeams = data.items;
        } else {
          this.rptsTeams = [];
        }
        this.totalResultsTeams.set(data?.total || 0);
      } catch (error) {
        console.error('Error loading team RPTs:', error);
        this.rptsTeams = [];
        this.totalResultsTeams.set(0);
      }
    }
  }

  getProtocolName(): string {
    if (!this.selectedAdhesion?.title) {
      return '';
    }

    const parts = this.selectedAdhesion.title.split(' - ');

    for (const part of parts) {
      if (part.includes('Protocolo ')) {
        return part.replace('Protocolo ', '');
      }
    }

    return this.selectedAdhesion.title;
  }

  async confirmSave() {
    const params = {
      jobCode: this.jobCode,
      idAdhesion: this.selectedAdhesion.id,
      puestos: this.selectedAdhesion.rpts.map((e) => e.jobCode),
    };
    const data = await this.rptsService.updateRpts(params);
    if (data) {
      this.toastService.showSuccess('Exito!', 'Se han modificado los rpts correctamente');
      this.visibleAllRpts = false;
    }
    return data;
  }

  confirm(event: Event) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'Va a modificar los Rpts. ¿Está seguro/a de que desea continuar?',
      header: 'Confirmación',
      closable: true,
      closeOnEscape: true,
      icon: 'pi pi-exclamation-triangle',
      rejectButtonProps: {
        label: 'Cancelar',
        severity: 'secondary',
        outlined: true,
      },
      acceptButtonProps: {
        label: 'Guardar',
      },
      accept: () => {
        this.confirmSave();
        this.location.back();
      },
    });
  }

  backPage(): void {
    this.location.back();
  }
}
